import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default function ToggleButton({
  toggled,
  handleClick,
  canRemove = false,
  text = "Toggle",
  toggledText = "Untoggle"
}) {
  const label = toggled ? toggledText : text;
  const style = {
    color: "#fff",
    borderColor: "#0398db",
    minWidth: "60px"
  };
  const classes = classNames(
    "btn btn-xs",
    classNames({
      "text-muted": toggled,
      "btn btn-primary": !toggled,
      "btn-default": toggled
    })
  );

  return (
    <button
      type="submit"
      onClick={handleClick}
      style={style}
      disabled={!canRemove}
      className={classes}
    >
      {label}
    </button>
  );
}

ToggleButton.propTypes = {
  toggled: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  canRemove: PropTypes.bool,
  text: PropTypes.string,
  toggledText: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/ToggleButton/ToggleButton.jsx